<div class="app-container">
  <header class="app-header" *ngIf="currentUser && !isShareRoute">
    <div class="header-top">
      <h1>🚀 Taptimize MK2</h1>
      <p class="header-tagline">SEO optimization and content analysis platform</p>
    </div>
    <nav class="nav-bar">
      <div class="nav-links">
        <!-- Core navigation (always visible) -->
        <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Dashboard</a>
        <a routerLink="/page-comparison" routerLinkActive="active">Compare</a>
        <a routerLink="/inventory" routerLinkActive="active">Inventory</a>

        <!-- Experimental navigation (feature-flagged) -->
        <a *ngIf="featureFlags.isEnabled('domainTopics')" routerLink="/domain-topics" routerLinkActive="active">Domain Topics</a>
        <a *ngIf="featureFlags.isEnabled('crawlManagement')" routerLink="/crawl-management" routerLinkActive="active">Crawl Management</a>
        <a *ngIf="featureFlags.isEnabled('keywordResearch')" routerLink="/keyword-research-test" routerLinkActive="active">Keyword Research</a>
        <ng-container *ngIf="featureFlags.isEnabled('topicShare')">
          <a routerLink="/topic-share" routerLinkActive="active">Topic Share</a>
          <a routerLink="/topic-share-2" routerLinkActive="active">Topic Share 2</a>
          <a routerLink="/topic-share-3" routerLinkActive="active">Topic Share 3</a>
        </ng-container>
      </div>

      <div class="nav-actions">
        <span class="nav-welcome">Welcome, {{ currentUser.name }}</span>
        <button (click)="logout()" class="btn-logout">Logout</button>
        <button (click)="toggleTheme()" type="button" aria-label="Toggle light/dark mode" class="btn-theme-toggle">
          <span id="theme-toggle-icon">🌙</span>
        </button>
      </div>
    </nav>
  </header>

  <!-- Dev/User View toggle (non-production only) -->
  <div class="dev-view-toggle" *ngIf="!featureFlags.isProduction() && currentUser && !isShareRoute">
    <button (click)="toggleDevUserView()" type="button" class="dev-toggle-btn">
      {{ featureFlags.isUserView() ? '👤 User View' : '🛠️ Dev View' }}
    </button>
  </div>

  <main>
    <router-outlet></router-outlet>
  </main>
</div>


